import React, { useCallback, useContext, useEffect, useState } from "react";
import { Button, Modal, Tabs } from "antd";
import MerchantLayout from "../../layout/MerchantLayout";
import { SubscriptionInfo, UserInfo } from "../../../context";
import moment from "moment";
import { useNavigate } from "react-router-dom";
import MerchantReports from "./report";
import MerchantVoid from "./void";
import MerchantWaste from "./waste";
import axios from "axios";
import MerchantFoodPandaReports from "./other-provider-transaction-report";
import MerchantAccountsReceivable from "./account-receivable";

const MerchantReport = () => {
  const { userData, handleLogoutTkn } = useContext(UserInfo);
  const { subscriptionDetails } = useContext(SubscriptionInfo);
  const dateNow = moment(new Date()).format("YYYY-MM-DD HH:mm:ss");
  const navigate = useNavigate();
  const [totalVoid, setTotalVoid] = useState(0);
  const [totalWaste, setTotalWaste] = useState(0);
  const [merchantWasteList, setMerchantWasteList] = useState({
    data: [],
    ready: false,
  });
  const [merchantVoidList, setMerchantVoidList] = useState({
    data: [],
    ready: false,
  });

  const items = [
    {
      key: "1",
      label: `Report`,
      children: (
        <MerchantReports
          rerunVoid={() => getMerchantVoidList()}
          rerunWaste={() => getMerchantWasteList()}
        />
      ),
    },
    {
      key: "4",
      label: `Account Receivable`,
      children: (
        <MerchantAccountsReceivable
          rerunVoid={() => getMerchantVoidList()}
          rerunWaste={() => getMerchantWasteList()}
        />
      ),
    },

    //ALLOW ADD FOOD PANDA /GRAB PUNCHTRANX
    userData.data.usersmerpermission.find(
      ({ permission }) => permission === "allow-punching-transaction"
    )
      ? {
          key: "5",
          label: `Other Report`,
          children: <MerchantFoodPandaReports />,
        }
      : null,

    {
      key: "2",
      label: `Void Transaction`,
      children: (
        <MerchantVoid
          merchantVoidList={merchantVoidList}
          setMerchantVoidList={setMerchantVoidList}
          total={totalVoid}
          setTotal={setTotalVoid}
        />
      ),
    },
    {
      key: "3",
      label: `Wastage`,
      children: (
        <MerchantWaste
          merchantWasteList={merchantWasteList}
          setMerchantWasteList={setMerchantWasteList}
          total={totalWaste}
          setTotal={setTotalWaste}
        />
      ),
    },
  ];

  const calculateTotal = (data) => {
    var total = 0;
    for (let i = 0; i < data.length; i++) {
      total += parseFloat(data[i].cost) * 1;
    }
    return total;
  };

  const getMerchantVoidList = useCallback(() => {
    var params = {
      user_id: userData.data.id,
    };
    axios
      .get("user/merchant/void-transaction-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantVoidList({ data, ready: true });
        setTotalVoid(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  const getMerchantWasteList = useCallback(() => {
    var params = {
      user_id: userData.data.id,
    };
    axios
      .get("user/merchant/waste-list", {
        params,
      })
      .then((response) => {
        const data = response.data;
        setMerchantWasteList({ data, ready: true });
        setTotalWaste(calculateTotal(data));
      })
      .catch((error) => {
        console.log("ERROR: ", error);
      });
  }, [userData.data.id]);

  useEffect(() => {
    getMerchantVoidList();
    getMerchantWasteList();
  }, [getMerchantVoidList, getMerchantWasteList]);

  return (
    <MerchantLayout>
      <Tabs defaultActiveKey="1" items={items} />

      <Modal
        title="Subscription has ended."
        centered
        open={dateNow > subscriptionDetails.data.plan_expiry}
        // open={false}
        footer={null}
        width={350}
        closable={false}
      >
        <div style={{ display: "flex" }}>
          <div style={{ flexGrow: 1 }} />
          <Button
            style={{ marginRight: 5 }}
            onClick={() => navigate("/renew-subscription")}
          >
            Renew
          </Button>
          <Button type="primary" onClick={() => handleLogoutTkn()}>
            Logout
          </Button>
        </div>
      </Modal>
    </MerchantLayout>
  );
};

export default MerchantReport;
